import { render, staticRenderFns } from "./WidgetFormFields.vue?vue&type=template&id=ffc51c90&"
import script from "./WidgetFormFields.vue?vue&type=script&lang=js&"
export * from "./WidgetFormFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports